import useWhitelabel from "hooks/useWhitelabel";
import styles from "./headerCustomLinksDesktop.module.scss";
import CustomLinkTab from "./components/CustomLinkTab/CustomLinkTab";
import wrapperHOC from "@Utils/wrapperHOC";
import React, { useEffect, useState } from "react";

const HeaderCustomLinksDesktop = () => {
  const { whitelabelConfig } = useWhitelabel();
  const [headerHeight, setHeaderHeight] = useState(64);

  useEffect(() => {
    const headerEl = document.getElementById("header");
    if (headerEl) {
      setHeaderHeight(headerEl.offsetHeight);
    }
  }, []);

  return (
    <div className={styles.container} style={{ top: `${headerHeight}px` }}>
      {whitelabelConfig?.custom_links?.map((link: any, index: number) => (
        <React.Fragment key={`custom-link-${link.title}-${index}`}>
          <CustomLinkTab title={link.title} link={link.link} />
          {index < whitelabelConfig.custom_links.length - 1 && (
            <span className={styles.separator} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default wrapperHOC(HeaderCustomLinksDesktop, {
  componentName: "HeaderCustomLinksDesktop",
});
